// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".round--normal[data-v-94155cd2]{border-color:#099;color:#099}.round--error[data-v-94155cd2],.round--normal[data-v-94155cd2]{width:36px;height:36px;border-radius:50%;border-style:solid;border-width:2px;position:relative}.round--error[data-v-94155cd2]{border-color:red;color:red}p[data-v-94155cd2]{font-weight:700;margin:0;position:absolute;top:45%;left:50%;margin-right:-50%;transform:translate(-50%,-50%)}", ""]);
// Exports
module.exports = exports;
